const ScheduleFormTopOptions = {
  All: 'All',
  Top: 'Top'
}

export default ScheduleFormTopOptions
